<template>
	<v-main>
		<v-container>
			<v-window disabled  v-model="step">
				<v-window-item v-for="(window, index) in windows" :key="index" :value="index">
					<v-card>
						<v-card-text>
							<component v-bind:is="getComponent(window.component)"
								:ref="window.code"
								v-model="item"
								:code="window.code"
								:title="window.title"
								:subtitle="window.subtitle"
								:text="window.text"
								:windows="windows"
								:step="step"
								@previous="onPrevious"
								@next="onNext"
								@step="onStep"
							></component>
						</v-card-text>
						<!-- <v-card-actions>
							<v-spacer></v-spacer>
							<v-btn
								class="mx-2"
								color="indigo"
								dark
								rounded
								block
							>
								Next
							</v-btn>
							<v-spacer></v-spacer>
						</v-card-actions> -->
					</v-card>
				</v-window-item>
			</v-window>
		</v-container>

		<!-- <v-bottom-navigation grow :elevation="1"> -->
		<!-- <v-bottom-navigation :value="value" absolute>

			<v-btn @click="drawer=!drawer" :disabled="disabledMenu">
				<v-icon>mdi-menu</v-icon>
				<span>{{ step+1 }} / {{ windows.length }}</span>
			</v-btn>

			<v-spacer></v-spacer>

			<v-btn v-if="step > 0" @click="onPrevious" value="recent">
				<v-icon>mdi-arrow-left-thick</v-icon>
				<span>Назад</span>
			</v-btn>

			<v-btn v-if="step < Object.keys(windows).length - 1" @click="onNext" value="nearby" :disabled="disabledNext">
				<v-icon>mdi-arrow-right-thick</v-icon>
				<span>Далі</span>
			</v-btn>

			<v-spacer></v-spacer>
		</v-bottom-navigation> -->

		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64" ></v-progress-circular>
		</v-overlay>
		<v-snackbar v-model="snackbar.visible" :color="snackbar.color">
			{{ snackbar.text }}
			<template v-slot:action="{ attrs }">
			<v-btn icon v-bind="attrs" @click="snackbar.visible = false" >
				<v-icon>mdi-close</v-icon>
			</v-btn>
			</template>
		</v-snackbar>

		<!-- <z-pdf ref="pdf" :item="item"></z-pdf> -->
	</v-main>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import axios from 'axios'
import mixin from './mixin/parameters'
//import zPdf from '@/views/pdf/VehicleEstimate'
//import downloadExcel from "vue-json-excel";

export default {
	name: 'VehicleAssessment',
	mixins: [mixin],
	components: {
		//zPdf,
		//downloadExcel
	},
	data: () => ({
		title: 'Оцінка транспортних засобів',
		subtitle: 'Інформація про складові частини транспортного засобу за VIN-кодом',
		loading: false,

		step: 0,
		drawer: false,

		value: 1,
		//favorit: {},

		/* excel: {
			name: '',
			type: 'xlsx',
			disabled: true,
			data: []
		}, */

		//excelType: 'xlsx',

		snackbar: {
			visible: false,
			text: null,
			color: null
		},

		windows: [
			{ component: 'VehicleIdentification' },
			{ component: 'VehicleRegistry' },
			{ component: 'VehicleOdometer' },

			{ component: 'Default', code: 'Card 1', name: 'Card 1', title: 'Card 1', errors: [], value: false },
			{ component: 'Default', code: 'Card 2', name: 'Card 2', title: 'Card 2', errors: [], value: false },
			/* { component: 'Oferta', code: 'Oferta', name: 'Оферта', title: 'Оферта', errors: [], value: false },
			{ component: 'Identification', code: 'Identification', name: 'Ідентифікація', title: 'Ідентифікація', errors: [], value: {} },
			{ component: 'Instruction', code: 'Instruction', name: 'Інструкція', title: 'Інструкція', errors: [] },

			//Фото з місця події
			{ component: 'Picture', code: 'Scene', name: 'Фото з місця події', title: 'Фото з місця події', errors: [], required: true, value: [] }, 

			//Фото пошкодженого автомобіля
			{ component: 'Picture', code: 'DemageGeneral', name: 'Загальний вигляд пошкоджень', title: 'Загальний вигляд пошкоджень', errors: [], required: false, value: [] },
			{ component: 'Picture', code: 'DemageDetail', name: 'Детальне фото пошкоджень', title: 'Детальне фото пошкоджень', errors: [], required: false, value: [] },
			{ component: 'Picture', code: 'FrontLeft', name: 'Передня ліва частина', title: 'Передня ліва частина', errors: [], required: false, value: [] },
			{ component: 'Picture', code: 'FrontRight', name: 'Передня права частина', title: 'Передня права частина', errors: [], required: false, value: [] },
			{ component: 'Picture', code: 'BackLeft', name: 'Задня ліва частина', title: 'Задня ліва частина', errors: [], required: false, value: [] },
			{ component: 'Picture', code: 'BackRight', name: 'Задня права частина', title: 'Задня права частина', errors: [], required: false, value: [] },
			{ component: 'Picture', code: 'Odometer', name: 'Пробіг', title: 'Одометр/пробіг', errors: [], required: false, value: [] },
			{ component: 'Picture', code: 'VIN', name: 'VIN-код', title: 'VIN-код/номер кузова', errors: [], required: false, value: [] },
			{ component: 'Picture', code: 'TireMarking', name: 'Фото маркування шин', title: 'Фото маркування шин', errors: [], required: false, value: [] },
			{ component: 'Picture', code: 'GlassMarking', name: 'Фото маркування скла', title: 'Фото маркування скла', errors: [], required: false, value: [] },

			//Фото документів
			{ component: 'Picture', code: 'VehicleCertificate', name: 'Свідоцтво про реєстрацію автомобіля', title: 'Свідоцтво про реєстрацію автомобіля', errors: [], required: false, value: [] },
			{ component: 'Picture', code: 'OwnershipCertificate', name: 'Свідоцтво про право власності', title: 'Свідоцтво про право власності', errors: [], required: false, value: [] },
			{ component: 'Picture', code: 'DriverLicense', name: 'Посвідчення водія', title: 'Посвідчення водія', errors: [], required: false, value: [] },
			{ component: 'Picture', code: 'Pasport', name: 'Паспорт', title: 'Паспорт власника автомобіля', errors: [], required: false, value: [] },
			{ component: 'Picture', code: 'Inn', name: 'ІПН', title: 'ІПН власника автомобіля', errors: [], required: false, value: [] },
			//{ value: 0, title: 'Європротокол або документ поліції', errors: [] },
			{ component: 'Picture', code: 'Europrotocol', name: 'Європротокол', title: 'Європротокол', errors: [], required: false, value: [] },
			{ component: 'Picture', code: 'PoliceDocument', name: 'Документ поліції', title: 'Документ поліції', errors: [], required: false, value: [] },
			{ component: 'Picture', code: 'CourtDocument', name: 'Постанова суду', title: 'Постанова суду', errors: [], required: false, value: [] },
			{ component: 'Picture', code: 'InsuranceContract', name: 'Договір страхування', title: 'Договір страхування', errors: [], required: false, value: [] },
			{ component: 'Picture', code: 'AdditionalDocument', name: 'Додаткові документи', title: 'Додатковий документ', errors: [], required: false, value: [] },
 */
			//Місце огляду автомобіля
			/* { 
				code: 'InspectionPlace'
				,name: 'Місце огляду'
				,title: 'Місце огляду автомобіля'
				,required: true
				,errors: []
			}, */

			//Відшкодування
			/* { 
				code: 'Refund'
				,name: 'Відшкодування'
				,title: 'Відшкодування'
				,subtitle: 'Просимо зазначити'
				,text: 'Який бажаний розмір страхового відшкодування і форма виплати?'
				,required: true
				,errors: []
			}, */

			//Контакти
			/* { 
				component: 'Contact'
				,code: 'Contact'
				,name: 'Контакти'
				,title: 'Контакти'
				,subtitle: 'Просимо надати'
				,text: 'Ваші контактні дані дозволять вподальшому швидше зкомунікувати з Вами!'
				,required: true
				,errors: []
				,value: {}
			},

			//Резюме
			{ 
				component: 'Summary'
				,code: 'Summary'
				,name: 'Перевірка'
				,title: 'Перевірка'
				,subtitle: ''
				,text: ''
				,errors: []
			},

			{ 
				component: 'SignDocument'
				,code: 'Document'
				,name: 'Підпис документів'
				,title: 'Підпис документів'
				,subtitle: ''
				,text: ''
				,errors: []
				,value: [
					{ title: 'Повідомлення про випадок', subtitle: 'Документ', icon: 'mdi-file-pdf-box', color: '#F40F02',
						href: "https://www.adobe.com/support/products/enterprise/knowledgecenter/media/c4611_sample_explain.pdf"
					},
					{ title: 'Заява на виплату', subtitle: 'Документ', icon: 'mdi-file-pdf-box', color: '#F40F02',
						href: "https://www.adobe.com/support/products/enterprise/knowledgecenter/media/c4611_sample_explain.pdf"
					},
				]
			},

			//Завершення
			{ 
				component: 'End'
				,code: 'End'
				,name: 'Завершення'
				,title: 'Дякуємо Вам!'
				,subtitle: ''
				,text: 'Процес надання інформації пройдено успішно!'
				,errors: []
			}, */
		],
	}),
	props: {
		
	},

	watch: {
		
	},
	
	computed: {
		...mapGetters('VehicleAssessment', [ 'item' ]),

		disabledNext() {
			return false //Тимчасово. Для прискориного тестування

			let result = !this.data.oferta

			let code = this.windows[this.step].code;
			switch(code) {
				case 'Identification':
					result = result || !this.data.ClaimNumber || !this.data.VehicleNumber; 
				break;
			}

			return result
		},

		disabledSummary() {
			return false //Тимчасово. Для прискориного тестування
			return !this.data.identity
		},

		disabledMenu() {
			return false //Тимчасово. Для прискориного тестування
			return !this.data.identity
		},

		/* id() {
			return this.item.hasOwnProperty('id') ? this.item.id: null;
		}, */

		/* favorit() {
			return this.favorits.find(element => element.id === this.id);
		}, */

		/* excelName() {
			return this.title + (this.vin ? ' ' + this.vin : '') + '.' +  this.excelType
		},

		estimates() {
			return this.item.hasOwnProperty('estimates') ? this.item.estimates: [];
		}, */
	},

	created() {
		const requireComponent = require.context("@/views/components/assessment", false, /[A-Z]\w+\.(vue|js)$/);
		requireComponent.keys().forEach(fileName => {
			const componentConfig = requireComponent(fileName);
			const componentName = `z${fileName.split("/").pop().split(".")[0]}`;
			this.$options.components[componentName] = componentConfig.default;
		});
	},

	methods: {
		...mapActions('VehicleAssessment', [ 'setItem' ]),

		getComponent(code) {
			const name = `z${code}`
			return this.$options.components[name] ? name : 'zDefault'
		},

		onPrevious() {
			this.step--
		},

		onNext() {
			//Тимчасово. Для прискориного тестування
			//this.step++
			//return;

			let code = this.windows[this.step].code;
			switch(code) {
				case 'Identification':
					this.onIdentification();
				break;
				default: this.step++
			}
		},

		/* onSummary() {
			this.checking()
			this.onStep('Summary')
		}, */

		onStep(e) {
			//console.log('onStep', 'e', e)
			this.step = isNaN(e) ? this.windows.findIndex((element) => element.code == e) : e;
		},

		onClear() {
			this.$refs.form.reset()
			//this.clear()
		},

		/* validate() {
			return this.params.vin
		}, */

		onOK() {
			if(this.$refs.form.validate()) {
			//if(this.validate()) {
				this.loading = true
				var that = this
				let params = { vin: this.params.vin };
				axios.post('/vehicle/assessment', params).then(response => {
					//console.log(that.$options.name, 'onOK','response.data', response.data)
					that.setItem(response.data)
				}, error => {
					console.log('error', error)

					that.snackbar.visible 	= true;
					that.snackbar.text 		= error.response.data.message;
					that.snackbar.color 	= null;
				}).finally(() => {
					this.loading = false
				});
			}/*  else {
				this.snackbar.visible 	= true;
				this.snackbar.text 		= 'Відсутні дані для пошуку';
				this.snackbar.color 	= null;
			} */
		},

		/* onClear() {
			this.$refs.form.reset()
		},

		onOK() {
			var that = this
			if (this.$refs.form.validate()) {
				//console.log(this.$options.name, 'onOK', 'VALID')
				this.loading = true
				axios.post('/vehicle/estimate/equipment', this.params).then(response => {
				//axios.post('/vehicle/estimate/identify', params).then(response => {
					//console.log(that.$options.name, 'onOK','response', response)
					//console.log(that.$options.name, 'onOK','response.data', response.data)

					that.setItem(response.data)
				}, error => {
					console.log('error', error)

					that.snackbar.visible 	= true;
					that.snackbar.text 		= error.response.data.message;
					that.snackbar.color 	= null;
				}).finally(() => {
					this.loading = false
					//console.log(this.$options.name, 'onOK','item', this.item)
				});
			}
		}, */

		onFavorit() {
			if(this.favorit) {
				this.removeFavorit(this.favorit) 
			} else {
				//console.log(this.$options.name, 'onFavorit','estimates', this.estimates)

				let vin, yearProd,category,brand,model,body,fuel,transmission,color,country;

				this.estimates.forEach(estimate => {
					//console.log(this.$options.name, 'onFavorit','equipments', estimate.equipments)

					vin = estimate.equipments.find(element => element.name === 'VIN')?.description;
					yearProd = estimate.equipments.find(element => element.name === 'Model Year')?.description;
					category = estimate.equipments.find(element => element.name === 'Product Type')?.description;
					brand = estimate.equipments.find(element => element.name === 'Make')?.description;
					model = estimate.equipments.find(element => element.name === 'Model')?.description;
					body = estimate.equipments.find(element => element.name === 'Body')?.description;
					fuel = estimate.equipments.find(element => element.name === 'Fuel Type - Primary')?.description;
					transmission = estimate.equipments.find(element => element.name === 'Transmission')?.description;
					color = estimate.equipments.find(element => element.name === 'Color')?.description;
					country = estimate.equipments.find(element => element.name === 'Plant Country')?.description;
					
					//console.log(this.$options.name, 'onFavorit','vin', vin)
				})

				let favorit = { 
					id: this.item.id,
					code: vin,
					name: vin,
					vin: vin,
					yearProd: yearProd
				}

				var that = this
				this.loading = true

				axios.get(`/vehicle/category/code/${category}`).then(response => {
					//console.log(that.$options.name, 'onOK','response.data', response.data)
					favorit['category'] = response.data
				}).then(() => axios.get(`/vehicle/brand/name/${brand}`).then(response => {
					favorit['brand'] = response.data
				})).then(() => axios.get(`/vehicle/brand/${brand}/model/name/${model}`).then(response => {
					favorit['model'] = response.data
				})).then(() => axios.get(`/vehicle/fuel/code/${fuel}`).then(response => {
					favorit['fuel'] = response.data
				//})).then(() => axios.get(`/vehicle/color/code/${color}`).then(response => {
				//	favorit['color'] = response.data
				})).then(() => axios.get(`/vehicle/country/code/${country}`).then(response => {
					favorit['country'] = response.data
				//})).then(() => axios.get(`/vehicle/body/code/${body}`).then(response => {
				//	favorit['body'] = response.data
				//})).then(() => axios.get(`/vehicle/transmission/code/${transmission}`).then(response => {
				//	favorit['transmission'] = response.data
				})).finally(() => {
					this.loading = false

					console.log(this.$options.name, 'onFavorit','favorit', favorit)

					this.addFavorit(favorit)
				});
			}
		},

		onPDF () {
			this.$refs.pdf.generate()
		},
	},
}
</script>